export default __webpack_public_path__ + "static/media/shrutiGsharp.63978a28.wav";